const styles = (theme) => ({
  cardContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    backgroundColor: "white",
    borderRadius: "12px",
    padding: theme.spacing(3),
    boxShadow:
      "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
    marginBottom: theme.spacing(3),
  },
  imageCardBackground: {
    margin: "0 auto",
    borderRadius: 8,
  },
  imageCardBackgroundTab: {
    margin: "0 auto",
    borderRadius: 8,
  },
  imageCardBackgroundInList: {
    marginLeft: 10,
    width: 50,
    height: 50,
    marginTop: 0,
    [theme.breakpoints.up("md")]: {
      width: 100,
      height: 100,
    },
  },
  imageCardBackgroundInListTab: {
    marginLeft: 10,
    width: 50,
    height: 50,
    marginTop: 0,
    [theme.breakpoints.up("md")]: {
      width: 100,
      height: 100,
    },
  },
  imageCardMedia: {
    width: "100%",
    height: "100%",
    backgroundColor: "#E5E8EB",
    borderRadius: 8,
  },
  imageInfos: {
    paddingTop: 18,
    paddingLeft: 8,
    color: "#4B5563",
    fontSize: "0.875rem",
    fontWeight: 600,
    "&:empty": {
      display: "none",
    },
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  modalContent: {
    backgroundColor: "white",
    borderRadius: 16,
    padding: theme.spacing(4),
    outline: "none",
    maxWidth: "90%",
    maxHeight: "90vh",
    overflow: "auto",
    position: "relative",
    paddingTop: theme.spacing(6),
    animation: "$modalEnter 0.3s ease-out",
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(2),
      paddingTop: theme.spacing(6),
      maxWidth: "95%",
    },
    "@media (prefers-reduced-motion: reduce)": {
      animation: "none",
    },
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(2),
    top: theme.spacing(2),
    color: theme.palette.grey[500],
    backgroundColor: "white",
    "&:hover": {
      backgroundColor: theme.palette.grey[100],
    },
    zIndex: 1,
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
  },
  previewButton: {
    backgroundColor: theme.palette.primary.main,
    color: "white",
    borderRadius: "8px",
    padding: 10,
    minWidth: 40,
    "& .MuiButton-startIcon": {
      margin: 0,
    },
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
      transform: "translateY(-1px)",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    },
    "&.Mui-focusVisible": {
      boxShadow: "0 0 0 3px rgba(35, 44, 72, 0.35)",
    },
    transition:
      "background-color 0.2s ease-in-out, transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
  },
  "@keyframes modalEnter": {
    "0%": {
      opacity: 0,
      transform: "scale(0.9)",
    },
    "100%": {
      opacity: 1,
      transform: "scale(1)",
    },
  },
  backdrop: {
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    backdropFilter: "blur(4px)",
  },
});

export default styles;
